export default {
  nav: {
    hotels: 'الفنادق',
    flights: 'الرحلات الجوية',
    localFlights: 'الرحلات المحلية',
    taxi: 'سيارة أجرة',
    packages: 'الباقات',
    thingsToDo: 'أشياء للقيام بها',
    hajjUmrah: 'الحج/العمرة',
    signIn: 'تسجيل الدخول',
    signUp: 'إنشاء حساب',
  },

  // Header Navigation
  'nav.hotels': 'الفنادق',
  'nav.flights': 'الرحلات الجوية',
  'nav.taxi': 'سيارة أجرة',
  'nav.packages': 'الباقات',
  'nav.thingsToDo': 'أشياء للقيام بها',
  'nav.hajjUmrah': 'الحج/العمرة',
  'nav.signIn': 'تسجيل الدخول',
  'nav.language': 'العربية',
  'nav.currency': 'USD',
  
  // Sign In Modal
  'signIn.title': 'تسجيل الدخول إلى Rigland Travels Ltd',
  'signIn.email': 'البريد الإلكتروني',
  'signIn.password': 'كلمة المرور',
  'signIn.emailPlaceholder': 'أدخل بريدك الإلكتروني',
  'signIn.passwordPlaceholder': 'أدخل كلمة المرور',
  'signIn.button': 'تسجيل الدخول',
  'signIn.noAccount': 'ليس لديك حساب؟',
  'signIn.createOne': 'إنشاء حساب',
  
  // Search Widget
  'search.hotels': 'الفنادق',
  'search.flights': 'الرحلات الجوية',
  'search.taxi': 'سيارة أجرة',
  'search.packages': 'الباقات',
  'search.thingsToDo': 'أشياء للقيام بها',
  'search.hajjUmrah': 'الحج/العمرة',
  'search.destination': 'إلى أين تذهب؟',
  'search.checkIn': 'تسجيل الوصول',
  'search.checkOut': 'تسجيل المغادرة',
  'search.guests': 'الضيوف',
  'search.searchButton': 'بحث',
  'search.from': 'من',
  'search.to': 'إلى',
  'search.departure': 'المغادرة',
  'search.return': 'العودة',
  'search.passengers': 'الركاب',
  'search.pickUp': 'موقع الاستلام',
  'search.dropOff': 'موقع التسليم',
  'search.pickUpDate': 'تاريخ الاستلام',
  'search.dropOffDate': 'تاريخ التسليم',
  'search.packageType': 'نوع الباقة',
  'search.activity': 'ماذا تريد أن تفعل؟',
  'search.date': 'التاريخ',
  'search.departureDate': 'تاريخ المغادرة',
  'search.returnDate': 'تاريخ العودة',
  'search.pilgrims': 'الحجاج',
  
  // Home Page
  'home.hero.title': 'رحلتك تبدأ هنا',
  'home.hero.subtitle': 'اكتشف وجهات مذهلة، احجز رحلات جوية وفنادق، وأنشئ ذكريات لا تُنسى مع Rigland Travels Ltd',
  'home.popularDestinations': 'الوجهات الشهيرة',
  'home.exploreWorld': 'استكشف العالم',
  'home.whyChooseUs': 'لماذا تختارنا',
  'home.bestPrices': 'أفضل الأسعار',
  'home.bestPricesDesc': 'نضمن لك أفضل الأسعار لجميع احتياجات سفرك',
  'home.support': 'دعم على مدار الساعة',
  'home.supportDesc': 'فريقنا متاح دائماً لمساعدتك',
  'home.easyBooking': 'حجز سهل',
  'home.easyBookingDesc': 'احجز رحلتك بنقرات قليلة فقط',
  'home.trustedPartner': 'شريك موثوق',
  'home.trustedPartnerDesc': 'أكثر من 10 سنوات من التميز في خدمات السفر',
  
  // Hotels Page
  'hotels.title': 'ابحث عن إقامتك المثالية',
  'hotels.subtitle': 'اكتشف فنادق مريحة في كادونا وما بعدها',
  'hotels.featured': 'الفنادق المميزة في كادونا',
  'hotels.categories': 'فئات الفنادق',
  'hotels.luxury': 'فنادق فاخرة',
  'hotels.business': 'فنادق الأعمال',
  'hotels.budget': 'فنادق اقتصادية',
  'hotels.perNight': 'لكل ليلة',
  'hotels.viewDetails': 'عرض التفاصيل',
  'hotels.rooms': 'الغرف',
  'hotels.adults': 'البالغون',
  'hotels.children': 'الأطفال',
  
  // Flights Page
  'flights.title': 'احجز رحلتك',
  'flights.subtitle': 'ابحث عن أفضل الرحلات الجوية إلى وجهتك',
  'flights.roundTrip': 'ذهاب وعودة',
  'flights.oneWay': 'ذهاب فقط',
  'flights.multiCity': 'مدن متعددة',
  'flights.popularRoutes': 'المسارات الشهيرة من كادونا',
  'flights.ourPartners': 'شركاؤنا من شركات الطيران',
  'flights.economy': 'الدرجة الاقتصادية',
  'flights.premiumEconomy': 'الدرجة الاقتصادية الممتازة',
  'flights.business': 'درجة الأعمال',
  'flights.firstClass': 'الدرجة الأولى',
  'flights.infants': 'الرضع',
  
  // Taxi Page
  'taxi.title': 'احجز سيارة أجرة',
  'taxi.subtitle': 'خدمات سيارات أجرة موثوقة إلى وجهتك',
  'taxi.categories': 'فئات سيارات الأجرة',
  'taxi.economy': 'اقتصادية',
  'taxi.standard': 'قياسية',
  'taxi.suv': 'سيارة دفع رباعي',
  'taxi.executive': 'تنفيذية',
  'taxi.serviceAreas': 'مناطق الخدمة في كادونا',
  'taxi.features': 'خدمات سيارات الأجرة لدينا',
  'taxi.professionalDrivers': 'سائقون محترفون',
  'taxi.professionalDriversDesc': 'سائقون ذوو خبرة ومهذبون',
  'taxi.safetyFirst': 'السلامة أولاً',
  'taxi.safetyFirstDesc': 'مركبات جيدة الصيانة مع التأمين',
  'taxi.affordablePrices': 'أسعار معقولة',
  'taxi.affordablePricesDesc': 'أسعار شفافة بدون رسوم خفية',
  'taxi.support': 'متاح على مدار الساعة',
  'taxi.supportDesc': 'احجز في أي وقت، في أي مكان',
  
  // Packages Page
  'packages.title': 'باقات السفر',
  'packages.subtitle': 'اكتشف باقات السفر المنسقة لتجارب لا تُنسى',
  'packages.categories': 'فئات الباقات',
  'packages.flightHotel': 'رحلة جوية + فندق',
  'packages.hajjUmrah': 'الحج والعمرة',
  'packages.allInclusive': 'شاملة كلياً',
  'packages.familyPackages': 'باقات عائلية',
  'packages.honeymoon': 'شهر العسل',
  'packages.adventure': 'مغامرة',
  'packages.vacation': 'باقات العطلات',
  'packages.specialDeals': 'عروض خاصة',
  'packages.perPerson': 'للشخص الواحد',
  'packages.days': 'أيام',
  'packages.bookNow': 'احجز الآن',
  'packages.save': 'وفر',
  
  // Things to Do Page
  'activities.title': 'أشياء للقيام بها في كادونا',
  'activities.subtitle': 'اكتشف أنشطة وتجارب مثيرة',
  'activities.categories': 'فئات الأنشطة',
  'activities.cultural': 'جولات ثقافية',
  'activities.adventure': 'مغامرة',
  'activities.foodDining': 'الطعام والمطاعم',
  'activities.shopping': 'التسوق',
  'activities.nature': 'الطبيعة والحياة البرية',
  'activities.entertainment': 'الترفيه',
  'activities.popular': 'الأنشطة الشهيرة',
  'activities.reviews': 'تقييمات',
  'activities.features': 'لماذا تحجز معنا',
  'activities.expertGuides': 'مرشدون خبراء',
  'activities.expertGuidesDesc': 'مرشدون محليون ذوو معرفة',
  'activities.bestValue': 'أفضل قيمة',
  'activities.bestValueDesc': 'أسعار تنافسية مضمونة',
  'activities.easyBooking': 'حجز سهل',
  'activities.easyBookingDesc': 'عملية حجز بسيطة وآمنة',
  'activities.instantConfirmation': 'تأكيد فوري',
  'activities.instantConfirmationDesc': 'احصل على التأكيد فوراً',
  
  // Hajj/Umrah Page
  'hajj.title': 'باقات الحج والعمرة',
  'hajj.subtitle': 'حقق رحلتك الروحية مع باقاتنا الشاملة',
  'hajj.packages': 'باقات الحج',
  'hajj.umrahPackages': 'باقات العمرة',
  'hajj.premium': 'ممتازة',
  'hajj.standard': 'قياسية',
  'hajj.luxury': 'فاخرة',
  'hajj.economy': 'اقتصادية',
  'hajj.days': 'أيام',
  'hajj.perPerson': 'للشخص الواحد',
  'hajj.bookNow': 'احجز الآن',
  'hajj.includes': 'تشمل الباقة',
  'hajj.flights': 'رحلات جوية ذهاباً وإياباً من كادونا',
  'hajj.accommodation': 'الإقامة في مكة والمدينة',
  'hajj.meals': 'وجبات يومية',
  'hajj.transport': 'النقل البري',
  'hajj.guidance': 'الإرشاد الديني',
  'hajj.visa': 'معالجة التأشيرة',
  'hajj.additionalServices': 'خدمات إضافية',
  'hajj.visaService': 'المساعدة في التأشيرة',
  'hajj.visaServiceDesc': 'دعم كامل لمعالجة التأشيرة',
  'hajj.insurance': 'تأمين السفر',
  'hajj.insuranceDesc': 'تغطية شاملة لراحة البال',
  'hajj.ziyarat': 'جولات الزيارة',
  'hajj.ziyaratDesc': 'جولات مرشدة للمواقع الإسلامية التاريخية',
  'hajj.religiousGuides': 'المرشدون الدينيون',
  'hajj.religiousGuidesDesc': 'علماء خبراء لإرشاد رحلتك',
  'hajj.ourGuides': 'مرشدونا الدينيون الخبراء',
  'hajj.yearsExperience': 'سنوات من الخبرة',
  
  // Footer
  'footer.about': 'عن Rigland Travels Ltd',
  'footer.aboutDesc': 'شريكك الموثوق لجميع احتياجات السفر في نيجيريا وخارجها. نقدم خدمة استثنائية للفنادق والرحلات الجوية وخدمات سيارات الأجرة والباقات ورحلات الحج والعمرة.',
  'footer.quickLinks': 'روابط سريعة',
  'footer.services': 'الخدمات',
  'footer.contact': 'اتصل بنا',
  'footer.phone': 'الهاتف',
  'footer.email': 'البريد الإلكتروني',
  'footer.address': 'العنوان',
  'footer.followUs': 'تابعنا',
  'footer.newsletter': 'اشترك في نشرتنا الإخبارية',
  'footer.newsletterDesc': 'احصل على أحدث عروض السفر والتحديثات',
  'footer.emailPlaceholder': 'أدخل بريدك الإلكتروني',
  'footer.subscribe': 'اشترك',
  'footer.rights': 'جميع الحقوق محفوظة',
  'footer.privacy': 'سياسة الخصوصية',
  'footer.terms': 'شروط الخدمة',
  
  // Common
  'common.loading': 'جاري التحميل...',
  'common.error': 'خطأ',
  'common.success': 'نجح',
  'common.cancel': 'إلغاء',
  'common.confirm': 'تأكيد',
  'common.close': 'إغلاق',
  'common.save': 'حفظ',
  'common.edit': 'تعديل',
  'common.delete': 'حذف',
  'common.viewMore': 'عرض المزيد',
  'common.learnMore': 'اعرف المزيد',
};

export const ar = {
  auth: {
    signIn: 'تسجيل الدخول',
    signUp: 'إنشاء حساب',
    signInSubtitle: 'مرحباً بعودتك! يرجى تسجيل الدخول إلى حسابك',
    signUpSubtitle: 'أنشئ حسابك لبدء حجز الرحلات المذهلة',
    signInWithGoogle: 'المتابعة مع جوجل',
    signUpWithGoogle: 'التسجيل مع جوجل',
    orContinueWith: 'أو المتابعة بالبريد الإلكتروني',
    firstName: 'الاسم الأول',
    lastName: 'اسم العائلة',
    phoneNumber: 'رقم الهاتف',
    emailAddress: 'عنوان البريد الإلكتروني',
    password: 'كلمة المرور',
    createAccount: 'إنشاء حساب',
    processing: 'جاري المعالجة...',
    agreeToTerms: 'أوافق على',
    termsOfService: 'شروط الخدمة',
    and: 'و',
    privacyPolicy: 'سياسة الخصوصية',
    noAccount: 'ليس لديك حساب؟',
    haveAccount: 'لديك حساب بالفعل؟',
    forgotPassword: 'نسيت كلمة المرور؟',
    registrationSuccess: 'تم التسجيل بنجاح!',
    registrationSuccessMessage: 'تم إنشاء حسابك بنجاح.',
    signinSuccess: 'مرحباً بعودتك!',
    signinSuccessMessage: 'تم تسجيل الدخول بنجاح.'
  }
};